import DapDSNumberInput from './number-input.component'

export * from './number-input.component'
export default DapDSNumberInput

DapDSNumberInput.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-number-input': DapDSNumberInput
  }
}
